import PieChart from "components/shared/Charts/PieChart";
import {
  Card,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";

function GenderDistributionModal({ genderModal, genderToggle, genderCounts }) {
  const maleCount = genderCounts?.male || genderCounts?.Male || 0;
  const femaleCount = genderCounts?.female || genderCounts?.Female || 0;
  const isEmptyData = maleCount === 0 && femaleCount === 0;
  const chartSeries = isEmptyData ? [] : [maleCount, femaleCount];

  const chartOptions = {
    chart: { type: "pie" },
    labels: ["Male", "Female"],
    legend: { fontFamily: "Poppins, sans-serif" },
    dataLabels: { enabled: true },
    tooltip: { enabled: true },
  };

  return (
    <Modal isOpen={genderModal} toggle={genderToggle}>
      <ModalHeader toggle={genderToggle}>Customer Demographics</ModalHeader>
      <ModalBody>
        <Container>
          <Row>
            <Col>
              <Card className="shadow mt-3">
                <PieChart
                  chartOptions={chartOptions}
                  chartSeries={chartSeries}
                  type="pie"
                />
              </Card>
            </Col>
          </Row>
        </Container>
      </ModalBody>
    </Modal>
  );
}

export default GenderDistributionModal;
